import { DatePipe } from '@angular/common';
import { Component, Inject } from '@angular/core'; 
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ApiService } from 'src/app/shared/services/api/api.service';

@Component({
  selector: 'app-due-date-dialog',
  templateUrl: './due-date-dialog.component.html',
  styleUrls: ['./due-date-dialog.component.less'],
  providers: [DatePipe]
})
export class DueDateDialogComponent {

  today = new Date();
  selectedDate: Date | null = null;
  dueDate: Date | null = null;
  reason = '';
  data: any;
  type: string = '';

  constructor(@Inject(MAT_DIALOG_DATA) data: any, private snackbar: MatSnackBar, private api: ApiService,
  
    private matDialog: MatDialog, private datePipe: DatePipe) {
      
    this.data = data;
    this.dueDate = this.parseLocalDate(data.dueDate);
    this.type = data.type;
  }


  selectDate(date: Date) {
    this.selectedDate = this.normalizeDate(date) ? date : null;
  }

  dateClass = (date: Date) => {
    if (this.selectedDate &&
      date.toDateString() === this.selectedDate.toDateString()) {
      return 'custom-selected-date';
    }

    if (this.isDueDate(date)) {
      return 'due-date';
    }

    if (this.isToday(date)) {
      return 'today-date';
    }

    return '';
  };


  dateFilter = (date: Date | null): boolean => {
    if (!date) return false;

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const compareDate = new Date(date);
    compareDate.setHours(0, 0, 0, 0);

    // allow today & future only
    return compareDate >= today;
  };

  isToday(date: Date): boolean {
    return date.toDateString() === this.today.toDateString();
  }

  isDueDate(date: Date): boolean {
    return !!this.dueDate && date.toDateString() === this.dueDate.toDateString();
  }

  isSelected(date: Date): boolean {
    return !!this.selectedDate && date.toDateString() === this.selectedDate.toDateString();
  }

isValid(): boolean {
  if (!this.selectedDate) return false;
  if (this.type === 'stage') {
    if (this.isAfterDueDate(this.selectedDate, this.dueDate)) {
      return this.reason?.trim().length > 0;
    }
    return true;
  }

  return this.reason?.trim().length > 0;
}


normalizeDate(d: Date): number {
  return new Date(
    d.getFullYear(),
    d.getMonth(),
    d.getDate()
  ).getTime();
}

isSameDay(d1: Date, d2: Date): boolean {
  return this.normalizeDate(d1) === this.normalizeDate(d2);
}

isAfterDueDate(d1: Date, d2: Date): boolean {
  // true only if selectedDate > dueDate (date only)
  return this.normalizeDate(d1) > this.normalizeDate(d2);
}



  updateMilestoneDueDate() {
    const formattedDate = this.datePipe.transform(this.selectedDate, 'yyyy-MM-dd');

    if (this.type === 'stage') {
      this.updateStage();
    } else {
      const data = {
        "room_id": this.data.rowData.room_id,
        "milestone_type": this.data.rowData.next_milestone_type,
        "new_due_date": formattedDate,
        "reason": this.reason
      };
      this.api.updateMilestoneDueDate(data).subscribe((res: any) => {
        console.log('Milestone due date updated', res);
        if (res.status) {
          this.snackbar.open('Milestone due date updated successfully', 'x', {
            duration: 5000,
          });
          this.matDialog.closeAll();

        } else {
          this.snackbar.open(res.message, 'x', {
            duration: 5000,
          });
        }
      }, err => {
        this.snackbar.open('Error updating milestone due date', 'x', {
          duration: 5000,
        });

      })
    }
  }

  updateStage() {
    const obj = {
      "room_id": this.data.rowData.room_id,
      "stage": "intro-sent",
      "design_start_date": this.selectedDate ? this.datePipe.transform(this.selectedDate, 'yyyy-MM-dd') : null,
      "internal_note": this.reason
    }

    this.api.updateDesignStatus(obj).subscribe((resp: any) => {
      if (resp && resp.success) {
        this.snackbar.open("Status updated successfully", "x", {
          duration: 2000,
        });
        this.matDialog.closeAll();
      } else {
        this.snackbar.open(resp.message || "Error updating status", "x", {
          duration: 2000,
        });

      }
    }, err => {
      this.snackbar.open(err.error.message || "Error updating status", "x", {
        duration: 2000,
      });
    });
  }
  parseLocalDate(dateStr: string | null): Date | null {
  if (!dateStr) return null;

  const [y, m, d] = dateStr.split('-').map(Number);
  return new Date(y, m - 1, d); // LOCAL date (no timezone shift)
}
}
